import styled from 'styled-components';

export const MediaImageSlot = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 0;
	overflow: hidden;
	isolation: isolate;
	background: #070509;
`;

export const MediaImageSkeletonWrap = styled.div`
	position: absolute;
	inset: 0;
	z-index: -2;
`;

export const MediaImage = styled.img`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover;
	object-position: ${(props) => props.$objectPosition || 'center center'};
	opacity: ${(props) => (props.$visible ? 1 : 0)};
	visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};
	transition: opacity 180ms ease, visibility 180ms ease, transform 180ms ease;
	z-index: -2;
`;
